import { useLocation } from "react-router-dom"
import classNames from "classnames"

import styles from "./Exercise.module.css"

const STEPS = [
  { label: "Values", path: /exercise(?!.*\/(strengths|results)).*./},
  { label: "Strengths", path: /\/strengths.*/ },
  { label: "Purpose", path: /\/results/ },
]

function Step({ label, path }: { label: string, path: RegExp | string }) {
  const { pathname } = useLocation()
  const classes = classNames(styles.stepCircle, {
    [styles.active]: pathname.match(path),
  })
  return <div className={classes}>{label}</div>
}

export default function Steps() {
  return (
    <div className={styles.stepContainer}>
      {STEPS.map(step => <Step key={step.label} label={step.label} path={step.path} />)}
    </div>
  )
}
